import { Link } from "react-router-dom";

export function MyFooter() {

  return (
    <footer className="content row" style={{ "marginTop": "20px" }}>
      <div className="col-md-12 ml-sm-auto col-lg-12 px-9">
        <ul className="nav nav-pills nav-fill justify-content-center">
          <li className="nav-item nav-link">
            <Link className="nav-link" to="/impressum/">Impressum</Link>
            <Link className="nav-link" to="/datenschutz/">Datenschutz</Link>
            <Link className="nav-link" to="https://www.concordia-neermoor.de/" target="_blank">Concordia Neermoor Homepage</Link>
          </li>
        </ul>
      </div>
    </footer>
  );
}
